export default "__VITE_ASSET__B072Ybnm__"